"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationRouterProvider = exports.useRouterContext = exports.RouterContext = void 0;
const react_1 = __importStar(require("react"));
const notImplement = () => {
    throw new Error('RouterContext error: actions not implemented, you must use RouterContext.Provider component');
};
exports.RouterContext = (0, react_1.createContext)({
    block: notImplement,
    unblock: notImplement,
    isBlocked: notImplement,
    goTo: notImplement,
    goBack: notImplement,
    replace: notImplement,
    resolvePath: notImplement,
    resolveAbsolutePath: notImplement,
    resolveRoute: notImplement,
    isActive: notImplement,
    isAllow: notImplement,
    match: notImplement,
    getParams: notImplement,
    getQuery: notImplement,
    getName: notImplement,
    getResourceName: notImplement
});
const useRouterContext = () => (0, react_1.useContext)(exports.RouterContext);
exports.useRouterContext = useRouterContext;
const NavigationRouterProvider = ({ children, router }) => {
    const routerRef = (0, react_1.useRef)(router);
    if (!routerRef.current.isActive()) {
        routerRef.current.run(window.location.href);
    }
    // TODO: remove to useRouterMatch
    const setCurrentMatchResult = (0, react_1.useState)(routerRef.current.getCurrentMatch())[1];
    (0, react_1.useEffect)(() => {
        const subscription = routerRef.current.asObservable().subscribe((result) => {
            setCurrentMatchResult(result);
        });
        return () => {
            subscription.unsubscribe();
            routerRef.current.terminate();
        };
    }, []);
    return (react_1.default.createElement(exports.RouterContext.Provider, { value: routerRef.current.getActions() }, children));
};
exports.NavigationRouterProvider = NavigationRouterProvider;
//# sourceMappingURL=RouterContext.js.map